import React, { useEffect, useRef } from "react";
import ReactPaginate from "react-paginate";
import tampuuriWindowObject from "../../tampuuriWindowObject.js";

/*
ReactPaginate doesnt support page start from index 1 
So keep page + 1 in url, -1 when fetching data, and variable currentPage -1
to show url page = 1, fetch data page = 0 and currentPage variable page = 0
 */
function PaginationComponent(props) {
  const { params, count, callBackUrlQuery } = props;
  const totalPages = Math.ceil(count / params.hitsPerPage);
  const currentPage = params.page - 1;
  const ref = useRef(null);
  const { translate } = tampuuriWindowObject();

  useEffect(() => {
    //This effect is only modifying each pagination items text and aria-label into translated version
    if (ref.current) {
      let section = ref.current;
      let ul = section.firstChild;
      ul.setAttribute("role", "list");
      const listItems = ul.querySelectorAll("li");

      for (let i = 0; i < listItems.length; i++) {
        const currentlinkElement = listItems[i].querySelector("a");
        const textAndNumber = currentlinkElement
          ?.getAttribute("aria-label")
          ?.split(" ");

        if (
          !listItems[i].classList.contains("active") &&
          !listItems[i].classList.contains("next") &&
          !listItems[i].classList.contains("prev")
        ) {
          listItems[i].classList.add("d-none", "d-sm-block");
        }

        if (listItems[i].classList.contains("dots")) {
          currentlinkElement.setAttribute(
            "aria-label",
            translate("Expand pages"),
          );
        } else {
          if (textAndNumber[0] && textAndNumber[1]) {
            currentlinkElement.setAttribute(
              "aria-label",
              translate(textAndNumber[0]) + " " + textAndNumber[1],
            );
          }
        }
      }
    }
  });

  const handlePageClick = (e) => {
    let final = { ...params, page: e.selected + 1, setFirstPage: false };
    callBackUrlQuery(final);
  };

  const chevronRight = () => {
    return (
      <span aria-hidden="true" className="hoas-svg-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <path d="M433 209L241 393c-5 5-11 7-17 7s-12-2-17-7L15 209c-9-9-10-24 0-34 9-9 24-9 34 0l175 168 175-168c10-9 25-9 34 0 10 10 9 25 0 34z"></path>
        </svg>
      </span>
    );
  };

  const chevronLeft = () => {
    return (
      <span aria-hidden="true" className="hoas-svg-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <path d="M433 209L241 393c-5 5-11 7-17 7s-12-2-17-7L15 209c-9-9-10-24 0-34 9-9 24-9 34 0l175 168 175-168c10-9 25-9 34 0 10 10 9 25 0 34z"></path>
        </svg>
      </span>
    );
  };

  return (
    <>
      {currentPage < totalPages && (
        <section ref={ref} className="pagination">
          <ReactPaginate
            breakLabel="..."
            nextLabel={chevronRight()}
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            pageCount={totalPages}
            previousLabel={chevronLeft()}
            pageClassName="pagination-list--item"
            pageLinkClassName="pagination-list--item--link page-number page-numbers"
            previousClassName="pagination-list--item prev"
            previousLinkClassName="pagination-list--item--link page-number page-numbers"
            nextClassName="pagination-list--item next"
            nextLinkClassName="pagination-list--item--link page-number page-numbers"
            breakClassName="pagination-list--item dots"
            breakLinkClassName="pagination-list--item--link page-number page-numbers"
            containerClassName="pagination-list"
            activeClassName="active"
            forcePage={currentPage}
            renderOnZeroPageCount={null}
          />
        </section>
      )}
    </>
  );
}

export default PaginationComponent;
